import { Box, Tooltip } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import ApartmentIcon from '@mui/icons-material/Apartment';
import TrainIcon from '@mui/icons-material/Train';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import FlightIcon from '@mui/icons-material/Flight';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import { useTranslation } from 'react-i18next';
import { meansOfTransportationOptions } from './NewTravelExpense';

// Maps each means of transportation to an icon. The two cars share the car
// icon and are told apart by a corner badge ("P" for private, building for
// company), mirroring the event creation form.
const meansIconMap = {
  'private-car': { Icon: DirectionsCarIcon, badge: 'P' },
  'company-car': { Icon: DirectionsCarIcon, BadgeIcon: ApartmentIcon },
  train: { Icon: TrainIcon },
  bus: { Icon: DirectionsBusIcon },
  taxi: { Icon: LocalTaxiIcon },
  bicycle: { Icon: DirectionsBikeIcon },
  airplane: { Icon: FlightIcon },
  boat: { Icon: DirectionsBoatIcon },
  'on-foot': { Icon: DirectionsWalkIcon },
};

export const meansOfTransportationLabel = (value) =>
  meansOfTransportationOptions.find((option) => option.value === value)
    ?.label || value;

// Renders the means of transportation as an icon wrapped in a tooltip showing
// the translated label. Used wherever space is tight (e.g. profile lists).
export const MeansOfTransportationIcon = ({ value, fontSize = '20px' }) => {
  const { t } = useTranslation();

  const config = meansIconMap[value] || { Icon: DirectionsCarIcon };
  const Icon = config.Icon;
  const label = t(meansOfTransportationLabel(value) || '');

  return (
    <Tooltip title={label} arrow>
      <Box
        component="span"
        sx={{ position: 'relative', display: 'inline-flex', lineHeight: 0 }}
      >
        <Icon sx={{ fontSize }} />
        {config.badge && (
          <Box
            component="span"
            sx={{
              position: 'absolute',
              top: '-5px',
              right: '-7px',
              fontSize: '9px',
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            {config.badge}
          </Box>
        )}
        {config.BadgeIcon && (
          <config.BadgeIcon
            sx={{
              position: 'absolute',
              top: '-6px',
              right: '-8px',
              fontSize: '11px',
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default MeansOfTransportationIcon;
